import { useState } from 'react'
import { ru } from '../data/ru';
import { by } from '../data/by';
import API from '../API'

export default function AddOrganization({additional,close}) {
    let language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdOne : by.RoleIdOne;
    const api = new API();
    const [form, setForm] = useState({
        'name': '',
        'parentId': localStorage.getItem('idOrganization')
    });

    const sendResults = (e) => {
        e.preventDefault();

        let resultJSON = {
            'name': form['name'],
            'parentId': form['parentId']
        };
        api.addOrganization(resultJSON).then(data => {
            additional();
            close();
        }).catch()
    }

    return (
        <div className='add'>
            <p className='add_text'>{language.addNewOrganization}</p>
            <form onSubmit={e => sendResults(e)}>
                <input
                    className="add_input"
                    placeholder={language.enterName}
                    onChange={e => setForm(current => {
                        current.name = e.target.value;
                        return current
                    })}
                />
                <button className="add_button"
                        value="Отправить"
                >{language.buttonAdd}</button>
            </form>
        </div>
    )
}